export const API_CONFIG = {
  BASE_URL: 'https://robocorp-telegram-be.datafabdevelopment.com',
  STUDIO_URL: 'https://promptify-studio-dev.promptyf.cloud/api', // TODO: replace
  SKIP_BROWSER_WARNING: '69420',
};

export const BOT_CONFIG = {
  BOT_USERNAME: 'RoboCorpCoBot',
  APP_NAME: 'RoboCorp',
};
